module.exports = __webpack_public_path__ + "static/media/loyalty.336799b4.png";